export type QType = 'single' | 'multi' | 'match'

export interface ImportQuestion {
    key: number
    type: QType
    text: string
    opts: Array<[string, string]>
    subs?: Array<[string, string]>
    // single/multi - letters of correct options; match - { itemLetter: optionLetter }
    correct: string[] | Record<string, string>
    hasImage: boolean
    imageNote?: string
    screenshot?: number
    ai?: boolean
}

export const MAX_MULTI = 3

// '' - вопрос готов к сохранению; иначе ключ сообщения об ошибке
export const issueOf = (q: ImportQuestion): '' | 'qiIssueMatch' | 'qiIssueMulti' | 'qiIssueSingle' => {
    if (q.type === 'match') {
        const c = q.correct as Record<string, string>
        return (q.subs || []).some((s) => !c[s[0]]) ? 'qiIssueMatch' : ''
    }
    const n = (q.correct as string[]).length
    if (q.type === 'multi') return n < 1 || n > MAX_MULTI ? 'qiIssueMulti' : ''
    return n !== 1 ? 'qiIssueSingle' : ''
}

export const emptyAnswer = (q: ImportQuestion) =>
    q.type === 'match'
        ? Object.keys(q.correct).length === 0
        : (q.correct as string[]).length === 0
